module.exports = __webpack_public_path__ + "static/balletbathmain-a5746f26b6117e9d3852b4c7bcf3c853.jpeg";